import React from "react";
import { useNavigate } from "react-router-dom";
import "./SuccessPage.css";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-header">
        <h2>Fiches envoyées !</h2>
      </div>

      <div className="success-content">
        <div className="success-card">
          <div className="success-icon">🍷</div>
          <h3>Merci pour votre participation</h3>
          <p>
            Vos fiches de dégustation ont bien été enregistrées.
            Un email avec vos notes personnalisées va vous être envoyé dans quelques instants.
          </p>
          <p className="success-hint">
            Pensez à vérifier vos spams si vous ne le recevez pas sous 5 minutes.
          </p>
          <button
            className="success-button"
            onClick={() => navigate("/")}
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
